export class Choice {
    id: number;
    optionid: number;
    name: string;
    metric: number;
    indent: number;
    cost: number;
    quantity: number;
    customfields: [];
    chainchoiceid?: string;
}
